/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Picker_EmptyInputs */

const vi_packaging_picker_empty = /** @type {(inputs: Packaging_Picker_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy vật tư.`)
};

/**

* @param {Packaging_Picker_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_picker_empty = /** @type {((inputs?: Packaging_Picker_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Picker_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_picker_empty(inputs)
});